import { Component, OnInit, AfterViewInit } from '@angular/core';
import { CartService } from 'app/main/services/cart.service';
import { BaseCartDirective } from 'app/main/cart.base';
import { AppService } from 'app/main/services/app.service';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
	selector: 'custom-header',
	templateUrl: './custom-header.component.html',
	styleUrls: ['./custom-header.component.scss']
})
export class CustomHeaderComponent extends BaseCartDirective implements OnInit, AfterViewInit {

	public show = false;

	constructor(
		public translate: TranslateService,
		public appService: AppService,
		public cartService: CartService){
		super(appService, translate, cartService);
	}

	ngOnInit(): void{
		super.ngOnInit();

		this.cartService.cartData.subscribe(cartData => {
			this.cartData = cartData;
		});
	}

	ngAfterViewInit(): void{
		this.cartService.loading.subscribe(isLoading => {
			if (isLoading) return;
			setTimeout(() => $('.shopping-cart > *').on('click', (event) => event.stopPropagation()));
		});
	}

	toggleCart(): void{
		if (!this.show){
			this.show = true;
		} else this.show = false;
	}
}
